export default "__VITE_ASSET__rQQ2SCE1__"